import { toValue } from 'vue';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import { useBrand } from './useBrand';

function shopSimilarItemsUrlMCOM() {
  const { taxonomy } = useCommonProductGetters();

  const { categories = [], defaultCategoryId } = toValue(taxonomy) || {};

  const defaultCategory = categories.find((category) => category.id === defaultCategoryId);

  return defaultCategory?.url || '';
}

function shopSimilarItemsUrlBCOM() {
  const { topLevelCategoryName, typeName } = useCommonProductGetters();
  const urlRoot = '/shop/search';
  const unwrappedTypeName = toValue(typeName) || '';
  const type = unwrappedTypeName.replace(/[^a-zA-Z0-9_\s-]/g, '').replace(/\s+|_/g, '+');
  const unwrappedTopLevelCategoryName = toValue(topLevelCategoryName);

  if (!unwrappedTopLevelCategoryName || !type) {
    return '';
  }

  const searchParamValue = encodeURIComponent(`${unwrappedTopLevelCategoryName} ${type}`.toLowerCase());

  return `${urlRoot}?keyword=${searchParamValue}`;
}

export default function useUnavailableProduct() {
  const { isMcom } = useBrand();
  return {
    similarItemsUrl: isMcom ? shopSimilarItemsUrlMCOM() : shopSimilarItemsUrlBCOM(),
  };
}
